import React from 'react';
import { Box, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

export default function MerchantDonut({ assigned, unassigned, total }) {
  const data = [
    {
      name: 'Assigned',
      value: assigned,
      gradient: 'url(#assignedGradient)',
      color: '#054EEE'
    },
    {
      name: 'Unassigned',
      value: unassigned,
      gradient: 'url(#unassignedGradient)',
      color: '#FF3C00'
    }
  ];

  // --- Tooltip bubble ---
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: '#fff',
            padding: '6px 10px',
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 700,
            color: '#171D40',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.15)'
          }}
        >
          {payload[0].value}
        </div>
      );
    }
    return null;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {/* Title */}
      <Box
        sx={{
          display: 'inline-block',
          px: 2.5,
          py: 1,
          borderRadius: 1,
          mb: 0.8,
          backgroundColor: '#F6F9FF',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '14px' }}>
          Merchant Stats
        </Typography>
      </Box>

      {/* Donut */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 110,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <defs>
              <linearGradient id="assignedGradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#BBD0FF" />
                <stop offset="100%" stopColor="#054EEE" />
              </linearGradient>

              <linearGradient id="unassignedGradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#FFC29C" />
                <stop offset="100%" stopColor="#FF3C00" />
              </linearGradient>
            </defs>

            <Tooltip content={<CustomTooltip />} cursor={false} />

            <Pie data={data} innerRadius={40} outerRadius={52} dataKey="value" nameKey="name">
              {data.map((entry, idx) => (
                <Cell key={idx} fill={entry.gradient} />
              ))}

              {/* Center Label */}
              <Label
                position="center"
                content={() => (
                  <text
                    x="50%"
                    y="42%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{
                      fontSize: '25px',
                      fontWeight: 700,
                      fill: '#171D40',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {total}
                    <tspan x="50%" dy="22" style={{ fontSize: 10, fontWeight: 600 }}>
                      Total
                    </tspan>
                    <tspan x="50%" dy="10" style={{ fontSize: 10, fontWeight: 600 }}>
                      Merchants
                    </tspan>
                  </text>
                )}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>

      {/* Legend */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 1
        }}
      >
        {data.map((item, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <svg width="7" height="7" viewBox="0 0 8 8">
              <circle cx="4" cy="4" r="4" fill={item.color} />
            </svg>

            <Typography sx={{ fontSize: 11, fontWeight: 700 }}>{item.name}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
